module.exports = __webpack_public_path__ + "img/50pts_records_bg.85ad45df.png";